export const serviceWorkerFetchStrategyHeader = 'X-SW-OHP-FetchStrategy';
